import React from 'react'
import {GoPlus} from 'react-icons/go'
import classnames from '@helpers/misc/classnames'

export interface Props {
  disabledProduct: boolean
  handleAddProduct: (e: React.MouseEvent<HTMLElement>) => Promise<any>
}

function AddProductButton(props: Props) {
  const {disabledProduct, handleAddProduct} = props
  return (
    <span
      className={classnames(
        'absolute right-2.5 bottom-2.5 p-2 rounded-full bg-black flex-1 text-white flex items-center justify-center border border-neutral-600',
        {
          'hover:bg-slate-700 hover:border-transparent': !disabledProduct,
          'opacity-40': disabledProduct
        }
      )}
      onClick={handleAddProduct}>
      <GoPlus />
    </span>
  )
}

export default AddProductButton
